import React, { useEffect, useState } from "react";
import { DaumPostcode } from "../../../../utils/DaumPostCode";
import * as R from "../../../../css/PersonalSellingRequest/requestForm";
import { Col, Container, Form, Row, Table } from "react-bootstrap";
import getUserInfo from "../../../../utils/hooks/getUserInfo";
import { toast } from "wc-toast";
import { postNumbaSelUserInfo } from "../../../../api/auth";

export default function CommonRegistration(props) {
  const { buyReqData, setBuyReqData, buyingData, setUserTypeCd, isEdit } = props;
   
  const MAX_FILE_SIZE = 5 * 1024 * 1024;

  const [isChecked, setIsChecked] = useState(!isEdit);
  const [userInfo, setUserInfo] = useState();
  const [isClick, setIsClick] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setBuyReqData({ ...buyReqData, [name]: value });
    // if (
    //   name === "corp_nm" ||
    //   name === "user_nm" ||
    //   name === "addr2"
    // ){
    //   setBuyReqData({ ...buyReqData, [name]: value?.trim()});
    // } else {
    //   setBuyReqData({ ...buyReqData, [name]: value });
    // }

    // if (name === "corp_nm" && value.trim() === "") {
    //   return toast.error("법인명을 입력해주세요.");
    // }
  };

  const handleCheckboxChange = async () => {
    setIsChecked(!isChecked);
    if (!isChecked) {
      setBuyReqData({
        ...buyReqData,
        user_nm: userInfo?.user_nm,
        phone: userInfo?.phone,
        corp_nm: userInfo?.corp_nm ?? "",
        zip: userInfo?.zip,
        addr1: userInfo?.addr1,
        addr2: userInfo?.addr2 ?? "",
      });
    } else {
      setBuyReqData({
        ...buyReqData,
        user_nm: "",
        phone: "",
        corp_nm: "",
        zip: "",
        addr1: "",
        addr2: "",
      });
    }
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    const name = e.target.name;
    if (!file) return;
    const allowedExtensions = ['jpg', 'jpeg', 'png', 'pdf'];
    const fileExtension = file.name.split('.').pop().toLowerCase();
    if (!allowedExtensions.includes(fileExtension)) {
      toast.error('지원되지 않는 파일 형식입니다. jpg, jpeg, png, pdf 파일만 업로드 가능합니다.');
      e.target.value = '';
      return;
    }

    if (file?.size > MAX_FILE_SIZE){
      toast.error('업로드할 수 없습니다. 파일 사이즈는 5MB 이하이어야 합니다.');
      e.target.value = '';
    } else {
      setBuyReqData({ ...buyReqData, [name]: file });
    }
  };

  const callUserInfo = async (buyingData) => {
    try {
      const response = await postNumbaSelUserInfo({});
      if (response.code === 1000) {
        setUserInfo(response);
        setUserTypeCd(response?.user_type_cd);
        if (isChecked) {
          setBuyReqData({
            ...buyingData,
            user_nm: response?.user_nm,
            phone: response?.phone,
            corp_nm: response?.corp_nm ?? "",
            zip: response?.zip,
            addr1: response?.addr1,
            addr2: response?.addr2 ?? "",
          });
        }
      } else {
        console.log("유저정보 가져오기 실패");
      }
    } catch (err) {
      console.log("유저정보 가져오기 실패");
    }
  };

  useEffect(() => {
    if (buyingData && buyReqData) {
      callUserInfo(buyingData);
    }
  }, [buyingData]);

  return (
    <div className="SecondSection">
      <div className="d-flex justify-content-between">
        <R.FormDetails_Heading>신청자 정보등록</R.FormDetails_Heading>
        <div>
          <Form.Check
            inline
            role="button"
            label="회원정보와 동일"
            name="group1"
            className="CustomCheckbox"
            checked={isChecked}
            onChange={handleCheckboxChange}
          />
        </div>
      </div>
      <R.FormDetails_Div>
        <div>
          <Table bordered responsive>
            <tbody>
              <tr>
                <R.FormTable_Th width="25%">신청자 유형</R.FormTable_Th>
                <td colSpan={3}>
                  <div className="d-flex gap-2 gap-md-3 ms-chk">
                    <Form.Check
                      inline
                      label="법인"
                      name="userInfoType"
                      type="radio"
                      className="CustomCheckbox"
                      checked={userInfo?.user_type_cd === 202 && true}
                      readOnly
                    />
                    <Form.Check
                      inline
                      label="개인"
                      name="userInfoType"
                      type="radio"
                      className="CustomCheckbox"
                      readOnly
                      checked={userInfo?.user_type_cd === 201 && true}
                    />
                  </div>
                </td>
              </tr>
              {userInfo?.user_type_cd === 202 && (
                <tr>
                  <R.FormTable_Th>법인명</R.FormTable_Th>
                  <td>
                    <R.Table_Input
                      value={buyReqData?.corp_nm?.trim()}
                      name="corp_nm"
                      onChange={(e) => {
                        handleChange(e);
                      }}
                    />
                  </td>
                </tr>
              )}
              <tr>
                <R.FormTable_Th>
                  {/* {buyReqData?.type === 2103 ? "임차인 이름" : "구매자 이름"} */}
                  이름
                </R.FormTable_Th>
                <td>
                  <R.Table_Input
                    value={buyReqData?.user_nm?.trim()}
                    name="user_nm"
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  />
                </td>
              </tr>
              <tr>
                <R.FormTable_Th>
                  {/* {buyReqData?.type === 2103 ? "임차인 " : "구매자 "} */}
                  휴대폰번호
                </R.FormTable_Th>
                <td>
                  <R.Table_Input
                    placeholder={"'-' 없이 입력"}
                    name={"phone"}
                    maxLength={11}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    value={buyReqData?.phone?.replace(/[^0-9]/g, "")}
                  />
                </td>
              </tr>
              <tr>
                <R.FormTable_Th>
                  {/* {buyReqData?.type === 2103 ? "임차인 " : "구매자 "} */}
                  주소
                </R.FormTable_Th>
                <td>
                  <div className="d-flex flex-column">
                    <div className="daum_search_wrapper">
                      <div className="d-flex w-100 mb-2">
                        <R.Table_Input
                          className="input-zip"
                          name={"zip"}
                          value={buyReqData?.zip}
                          readOnly={true}
                        ></R.Table_Input>
                        <DaumPostcode
                          className="btn btn-primary btn-zip border-sm-1 h-md-46px h-sm-36px"
                          onCompleteCallback={(data) => {
                            setBuyReqData({
                              ...buyReqData,
                              zip: data.zonecode,
                              addr1: data.fullAddr,
                            });
                          }}
                        />
                      </div>
                      <R.TableInput_Search
                        width={"100%"}
                        name={"addr1"}
                        value={buyReqData?.addr1}
                        readOnly={true}
                        className="ms-0 mb-2 h-sm-36px"
                      ></R.TableInput_Search>
                    </div>
                    <R.TableInput_Search
                      width={"w-100"}
                      className={"h-sm-36px"}
                      name={"addr2"}
                      value={buyReqData?.addr2?.trim() ?? ""}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      placeholder={"상세 주소 입력 (선택)"}
                    ></R.TableInput_Search>
                  </div>
                </td>
              </tr>
              {buyReqData?.type === 2103 && (
                <tr>
                  <R.FormTable_Th>자동차등록증<br/>(선택)</R.FormTable_Th>
                  <td>
                    <div className="d-flex align-items-center">
                      <label className="fileBtn" htmlFor="carFile">
                        파일선택
                      </label>
                      <input
                        type="file"
                        style={{ display: "none" }}
                        id="carFile"
                        name="car_file"
                        onChange={(e) => handleFileSelect(e)}
                        accept=".jpg, .jpeg, .png, .pdf"
                      />
                      <div className="txt_attach ms-2">
                        {buyReqData?.car_file
                          ? buyReqData?.car_file?.name
                          : buyReqData?.car_file_nm}
                      </div>
                    </div>
                    <R.Btn_Value
                      className="d-lg-inline-block"
                      color="#f60"
                    >
                      ※ 사진, 이미지, PDF 파일로 제출해주세요.&nbsp;<br/>
                    </R.Btn_Value>
                    <R.Btn_Value
                      className="d-lg-inline-block"
                      color="#8c8c8c"
                    >
                      (최대 5MB까지, jpg, jpeg, png, pdf만 가능)
                    </R.Btn_Value>
                  </td>
                </tr>
              )}
              {buyReqData?.type === 2103 && (
                <tr>
                  <R.FormTable_Th>화물운송자격증<br/>(선택)</R.FormTable_Th>
                  <td>
                    <div className="d-flex align-items-center">
                      <label className="fileBtn" htmlFor="fw_file">
                        파일선택
                      </label>
                      <input
                        type="file"
                        style={{ display: "none" }}
                        id="fw_file"
                        name="fw_file"
                        onChange={(e) => handleFileSelect(e)}
                        accept=".jpg, .jpeg, .png, .pdf"
                      />
                      <div className="txt_attach ms-2">
                        {buyReqData?.fw_file
                          ? buyReqData?.fw_file?.name
                          : buyReqData?.fw_file_nm}
                      </div>
                    </div>
                    <R.Btn_Value
                      className="d-lg-inline-block"
                      color="#f60"
                    >
                      ※ 사진, 이미지, PDF 파일로 제출해주세요.&nbsp;<br/>
                    </R.Btn_Value>
                    <R.Btn_Value
                      className="d-lg-inline-block"
                      color="#8c8c8c"
                    >
                      (최대 5MB까지, jpg, jpeg, png, pdf만 가능)
                    </R.Btn_Value>
                  </td>
                </tr>
              )}
              <tr>
                <R.FormTable_Th>요청내용</R.FormTable_Th>
                <td>
                  <R.Table_Textarea
                    className="w-100"
                    rows={4}
                    name="req_comment"
                    value={buyReqData?.req_comment}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                  ></R.Table_Textarea>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </R.FormDetails_Div>
    </div>
  );
}
